import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Storybook",
  "description": "Turborepo에서 Storybook을 사용하는 방법을 알아보세요."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Storybook은 격리된 환경에서 UI 컴포넌트를 빌드하는 인기 있는 방법입니다. Storybook을 Turborepo에 넣으면 애플리케이션과 함께 디자인 시스템을 쉽게 개발할 수 있습니다."
  }, {
    "heading": "빠른-시작",
    "content": "템플릿을 사용하려는 경우, 이 가이드는 Vercel에서 이 Storybook/Turborepo 템플릿을 빌드하는 방법을 안내합니다."
  }, {
    "heading": "monorepo-만들기",
    "content": "기존 프로젝트가 없는 경우, create-turbo를 사용하여 새 monorepo를 만듭니다:"
  }, {
    "heading": "앱용-디렉터리-생성",
    "content": "Storybook 애플리케이션용 디렉터리가 필요합니다:"
  }, {
    "heading": "storybook-애플리케이션-추가",
    "content": "apps/storybook 디렉터리에서 새 Storybook 애플리케이션을 초기화합니다:"
  }, {
    "heading": "storybook-애플리케이션-추가",
    "content": "프롬프트에 따라 애플리케이션을 만듭니다. 이 가이드의 나머지 부분에서는 React 및 TypeScript를 사용한다고 가정합니다."
  }, {
    "heading": "storybook-애플리케이션-추가",
    "content": "Storybook의 온보딩을 완료한 후 온보딩 애드온을\n제거할\n수 있습니다."
  }, {
    "heading": "storybook에-ui-키트-추가",
    "content": "이제 UI 패키지를 Storybook에 설치합니다."
  }, {
    "heading": "button-컴포넌트에-대한-스토리-설정",
    "content": "Storybook 스캐폴딩 도구로 생성된 src/stories에서 스토리 및 컴포넌트를 삭제합니다. 직접 만들 것입니다."
  }, {
    "heading": "button-컴포넌트에-대한-스토리-설정",
    "content": "예를 들어, @repo/ui/button의 Button 컴포넌트에 대한 스토리는 다음과 같습니다."
  }, {
    "heading": "작업에-스크립트-정렬",
    "content": "마지막으로, 새 Storybook 애플리케이션을 Turborepo에 통합합니다:"
  }, {
    "heading": "작업에-스크립트-정렬",
    "content": "이제 이러한 스크립트는 turbo.json의 turbo dev 및 turbo build 작업과 함께 실행됩니다."
  }, {
    "heading": "작업에-스크립트-정렬",
    "content": "build를 실행할 때 파일 출력이 캐시되도록 하려면 turbo.json 빌드 작업의 출력에 storybook-static을 추가합니다:"
  }, {
    "heading": "storybook-빌드-출력을-gitignore에-추가",
    "content": "Storybook의 빌드 출력이 소스 제어에 커밋되지 않도록 합니다"
  }, {
    "heading": "구성-확인",
    "content": "turbo build를 실행하여 Storybook 애플리케이션과 나머지 애플리케이션을 함께 빌드합니다."
  }, {
    "heading": "구성-확인",
    "content": "turbo build를 다시 실행하여 빌드에 대한 캐시 적중을 볼 수도 있습니다."
  }, {
    "heading": "스토리-같은-위치-배치",
    "content": "스토리를 소스 코드와 함께 배치하려는 경우(Storybook 애플리케이션에 있는 대신), 몇 가지 추가 구성이 필요합니다."
  }, {
    "heading": "re-configure-storybook-sources",
    "content": "In .storybook/main.ts, change the stories paths in config to the directories you'd like to capture. For instance, if you'd like to write stories in the UI package:"
  }, {
    "heading": "move-story-files-to-the-ui-package",
    "content": "Following along with the guide above, move the ./apps/storybook/src/stories/Button.stories.tsx file to ./packages/ui/src/Button.stories.tsx."
  }, {
    "heading": "move-story-files-to-the-ui-package",
    "content": "Update components imports so that they reference the now co-located modules. For instance, in the story's imports:"
  }, {
    "heading": "move-story-files-to-the-ui-package",
    "content": "You may also need to update absolute\nimports\naccording to your changes and usage."
  }, {
    "heading": "move-story-files-to-the-ui-package",
    "content": "You'll also need to install any Storybook packages required for writing stories. For example, moving the story from above would require that you install @storybook/react into your @repo/ui package."
  }, {
    "heading": "configure-caching",
    "content": "Because stories are now in the UI package, changes to those stories can cause cache misses for any builds that depend on your UI package. However, changing a story doesn't mean your production applications should miss cache."
  }, {
    "heading": "configure-caching",
    "content": "To prevent this, exclude stories from the inputs to your build task in your root turbo.json. You'll also need to create a build:storybook task, which you'll need in a moment:"
  }, {
    "heading": "configure-caching",
    "content": "Additionally, create a Package Configuration in the storybook application so stories are accounted for in building the Storybook application, specifically:"
  }, {
    "heading": "configure-caching",
    "content": "If you are using the Compiled Package\npattern, you may\nalso need to add ^build to your dependsOn."
  }, {
    "heading": "rename-the-build-script",
    "content": "Last, make sure your script to build Storybook uses the configuration we just wrote by renaming it to the name of the task:"
  }, {
    "heading": "rename-the-build-script",
    "content": "The script that was once \"build\" is now \"build:storybook\" to ensure the stories are included in hashes for caching."
  }, {
    "heading": "verify-your-configuration",
    "content": "To ensure your setup is correct:"
  }, {
    "heading": "verify-your-configuration",
    "content": "Run turbo build:storybook build. You should see cache misses."
  }, {
    "heading": "verify-your-configuration",
    "content": "Run turbo build:storybook build again. You should see all cache hits."
  }, {
    "heading": "verify-your-configuration",
    "content": "Make a code change to a story in your @repo/ui package."
  }, {
    "heading": "verify-your-configuration",
    "content": "Run turbo build:storybook build again. You should only see a cache miss for the Storybook application. All others should hit cache."
  }, {
    "heading": "adding-css",
    "content": "If your UI package exports its own CSS, you'll need to add it to the renders in the Storybook app, similar to how you would add it to your applications. The Storybook documentation recommends you add it to the .storybook/preview.ts file."
  }],
  "headings": [{
    "id": "빠른-시작",
    "content": "빠른 시작"
  }, {
    "id": "가이드",
    "content": "가이드"
  }, {
    "id": "monorepo-만들기",
    "content": "monorepo 만들기"
  }, {
    "id": "앱용-디렉터리-생성",
    "content": "앱용 디렉터리 생성"
  }, {
    "id": "storybook-애플리케이션-추가",
    "content": "Storybook 애플리케이션 추가"
  }, {
    "id": "storybook에-ui-키트-추가",
    "content": "Storybook에 UI 키트 추가"
  }, {
    "id": "button-컴포넌트에-대한-스토리-설정",
    "content": "Button 컴포넌트에 대한 스토리 설정"
  }, {
    "id": "작업에-스크립트-정렬",
    "content": "작업에 스크립트 정렬"
  }, {
    "id": "storybook-빌드-출력을-gitignore에-추가",
    "content": "Storybook 빌드 출력을 .gitignore에 추가"
  }, {
    "id": "구성-확인",
    "content": "구성 확인"
  }, {
    "id": "더-많은-팁",
    "content": "더 많은 팁"
  }, {
    "id": "스토리-같은-위치-배치",
    "content": "스토리 같은 위치 배치"
  }, {
    "id": "re-configure-storybook-sources",
    "content": "Re-configure Storybook sources"
  }, {
    "id": "move-story-files-to-the-ui-package",
    "content": "Move story files to the UI package"
  }, {
    "id": "configure-caching",
    "content": "Configure caching"
  }, {
    "id": "rename-the-build-script",
    "content": "Rename the build script"
  }, {
    "id": "verify-your-configuration",
    "content": "Verify your configuration"
  }, {
    "id": "adding-css",
    "content": "Adding CSS"
  }]
};
import {PackageManagerTabs, Tab} from '#components/tabs';
import {Callout} from '#components/callout';
import {Steps, Step} from '#components/steps';
export const toc = [{
  depth: 2,
  url: "#빠른-시작",
  title: _jsx(_Fragment, {
    children: "빠른 시작"
  })
}, {
  depth: 2,
  url: "#가이드",
  title: _jsx(_Fragment, {
    children: "가이드"
  })
}, {
  depth: 3,
  url: "#monorepo-만들기",
  title: _jsx(_Fragment, {
    children: "monorepo 만들기"
  })
}, {
  depth: 3,
  url: "#앱용-디렉터리-생성",
  title: _jsx(_Fragment, {
    children: "앱용 디렉터리 생성"
  })
}, {
  depth: 3,
  url: "#storybook-애플리케이션-추가",
  title: _jsx(_Fragment, {
    children: "Storybook 애플리케이션 추가"
  })
}, {
  depth: 3,
  url: "#storybook에-ui-키트-추가",
  title: _jsx(_Fragment, {
    children: "Storybook에 UI 키트 추가"
  })
}, {
  depth: 3,
  url: "#button-컴포넌트에-대한-스토리-설정",
  title: _jsx(_Fragment, {
    children: "Button 컴포넌트에 대한 스토리 설정"
  })
}, {
  depth: 3,
  url: "#작업에-스크립트-정렬",
  title: _jsx(_Fragment, {
    children: "작업에 스크립트 정렬"
  })
}, {
  depth: 3,
  url: "#storybook-빌드-출력을-gitignore에-추가",
  title: _jsxs(_Fragment, {
    children: ["Storybook 빌드 출력을 ", _jsx("code", {
      children: ".gitignore"
    }), "에 추가"]
  })
}, {
  depth: 3,
  url: "#구성-확인",
  title: _jsx(_Fragment, {
    children: "구성 확인"
  })
}, {
  depth: 2,
  url: "#더-많은-팁",
  title: _jsx(_Fragment, {
    children: "더 많은 팁"
  })
}, {
  depth: 3,
  url: "#스토리-같은-위치-배치",
  title: _jsx(_Fragment, {
    children: "스토리 같은 위치 배치"
  })
}, {
  depth: 4,
  url: "#re-configure-storybook-sources",
  title: _jsx(_Fragment, {
    children: "Re-configure Storybook sources"
  })
}, {
  depth: 4,
  url: "#move-story-files-to-the-ui-package",
  title: _jsx(_Fragment, {
    children: "Move story files to the UI package"
  })
}, {
  depth: 4,
  url: "#configure-caching",
  title: _jsx(_Fragment, {
    children: "Configure caching"
  })
}, {
  depth: 4,
  url: "#rename-the-build-script",
  title: _jsx(_Fragment, {
    children: "Rename the build script"
  })
}, {
  depth: 4,
  url: "#verify-your-configuration",
  title: _jsx(_Fragment, {
    children: "Verify your configuration"
  })
}, {
  depth: 3,
  url: "#adding-css",
  title: _jsx(_Fragment, {
    children: "Adding CSS"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://storybook.js.org/",
        children: "Storybook"
      }), "은 격리된 환경에서 UI 컴포넌트를 빌드하는 인기 있는 방법입니다. Storybook을 Turborepo에 넣으면 애플리케이션과 함께 디자인 시스템을 쉽게 개발할 수 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "빠른-시작",
      children: "빠른 시작"
    }), "\n", _jsxs(_components.p, {
      children: ["템플릿을 사용하려는 경우, 이 가이드는 Vercel에서 ", _jsx(_components.a, {
        href: "https://vercel.com/templates/react/turborepo-design-system",
        children: "이 Storybook/Turborepo 템플릿"
      }), "을 빌드하는 방법을 안내합니다."]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " design-system"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " design-system"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " design-system"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " design-system"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "가이드",
      children: "가이드"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "monorepo-만들기",
          children: "monorepo 만들기"
        }), _jsxs(_components.p, {
          children: ["기존 프로젝트가 없는 경우, ", _jsx(_components.a, {
            href: "/docs/getting-started/installation",
            children: "create-turbo"
          }), "를 사용하여 새 monorepo를 만듭니다:"]
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bunx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "앱용-디렉터리-생성",
          children: "앱용 디렉터리 생성"
        }), _jsx(_components.p, {
          children: "Storybook 애플리케이션용 디렉터리가 필요합니다:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "mkdir"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " apps/storybook"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "cd"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " apps/storybook"
                })]
              })]
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "storybook-애플리케이션-추가",
          children: "Storybook 애플리케이션 추가"
        }), _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "apps/storybook"
          }), " 디렉터리에서 새 Storybook 애플리케이션을 초기화합니다:"]
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook@latest"
                    })]
                  })
                })
              })
            })
          })]
        }), _jsx(_components.p, {
          children: "프롬프트에 따라 애플리케이션을 만듭니다. 이 가이드의 나머지 부분에서는 React 및 TypeScript를 사용한다고 가정합니다."
        }), _jsx(Callout, {
          type: "good-to-know",
          children: _jsxs(_components.p, {
            children: ["Storybook의 온보딩을 완료한 후 ", _jsx(_components.a, {
              href: "https://github.com/storybookjs/addon-onboarding/blob/main/README.md",
              children: "온보딩 애드온을\n제거"
            }), "할\n수 있습니다."]
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "storybook에-ui-키트-추가",
          children: "Storybook에 UI 키트 추가"
        }), _jsx(_components.p, {
          children: "이제 UI 패키지를 Storybook에 설치합니다."
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=storybook"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " workspace"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --workspace=storybook"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=storybook"
                    })]
                  })
                })
              })
            })
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "button-컴포넌트에-대한-스토리-설정",
          children: "Button 컴포넌트에 대한 스토리 설정"
        }), _jsxs(_components.p, {
          children: ["Storybook 스캐폴딩 도구로 생성된 ", _jsx(_components.code, {
            children: "src/stories"
          }), "에서 스토리 및 컴포넌트를 삭제합니다. 직접 만들 것입니다."]
        }), _jsxs(_components.p, {
          children: ["예를 들어, ", _jsx(_components.code, {
            children: "@repo/ui/button"
          }), "의 ", _jsx(_components.code, {
            children: "Button"
          }), " 컴포넌트에 대한 스토리는 다음과 같습니다."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/storybook/src/stories/Button.stories.tsx",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " type"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " { Meta"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " StoryObj } "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '@storybook/react'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " { Button } "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '@repo/ui/button'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "const"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " meta"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " ="
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  title"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'Example/Button'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  component"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " Button"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  tags"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "'autodocs'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "} "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "satisfies"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " Meta"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "<"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "typeof"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " Button>;"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " meta;"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "type"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " Story"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " ="
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " StoryObj"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "<"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "typeof"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " meta>;"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " const"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " Primary"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " Story"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " ="
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  args"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    appName"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'Button'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    children"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'I am a primary button.'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "};"
                })
              })]
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "작업에-스크립트-정렬",
          children: "작업에 스크립트 정렬"
        }), _jsx(_components.p, {
          children: "마지막으로, 새 Storybook 애플리케이션을 Turborepo에 통합합니다:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "apps/storybook/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"storybook dev -p 6006\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"storybook build\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["이제 이러한 스크립트는 ", _jsx(_components.code, {
            children: "turbo.json"
          }), "의 ", _jsx(_components.code, {
            children: "turbo dev"
          }), " 및 ", _jsx(_components.code, {
            children: "turbo build"
          }), " 작업과 함께 실행됩니다."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "build"
          }), "를 실행할 때 파일 출력이 캐시되도록 하려면 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 빌드 작업의 출력에 ", _jsx(_components.code, {
            children: "storybook-static"
          }), "을 추가합니다:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"tasks\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"outputs\": ["
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        \".next/**\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        \"!.next/cache/**\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+       \"storybook-static/**\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(Step, {
          children: [_jsxs(_components.h3, {
            id: "storybook-빌드-출력을-gitignore에-추가",
            children: ["Storybook 빌드 출력을 ", _jsx(_components.code, {
              children: ".gitignore"
            }), "에 추가"]
          }), _jsx(_components.p, {
            children: "Storybook의 빌드 출력이 소스 제어에 커밋되지 않도록 합니다"
          }), _jsx(_Fragment, {
            children: _jsx(_components.pre, {
              className: "shiki shiki-themes css-variables css-variables",
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)",
                "--shiki-light-bg": "var(--shiki-background)",
                "--shiki-dark-bg": "var(--shiki-background)"
              },
              tabIndex: "0",
              title: ".gitignore",
              icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
              children: _jsx(_components.code, {
                children: _jsx(_components.span, {
                  className: "line",
                  children: _jsx(_components.span, {
                    style: {
                      "--shiki-light": "var(--shiki-token-inserted)",
                      "--shiki-dark": "var(--shiki-token-inserted)"
                    },
                    children: "+ storybook-static"
                  })
                })
              })
            })
          })]
        }), _jsxs(Step, {
          children: [_jsx(_components.h3, {
            id: "구성-확인",
            children: "구성 확인"
          }), _jsxs(_components.p, {
            children: [_jsx(_components.code, {
              children: "turbo build"
            }), "를 실행하여 Storybook 애플리케이션과 나머지 애플리케이션을 함께 빌드합니다."]
          }), _jsxs(_components.p, {
            children: [_jsx(_components.code, {
              children: "turbo build"
            }), "를 다시 실행하여 빌드에 대한 캐시 적중을 볼 수도 있습니다."]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "더-많은-팁",
      children: "더 많은 팁"
    }), "\n", _jsx(_components.h3, {
      id: "스토리-같은-위치-배치",
      children: "스토리 같은 위치 배치"
    }), "\n", _jsx(_components.p, {
      children: "스토리를 소스 코드와 함께 배치하려는 경우(Storybook 애플리케이션에 있는 대신), 몇 가지 추가 구성이 필요합니다."
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "re-configure-storybook-sources",
          children: "Re-configure Storybook sources"
        }), _jsxs(_components.p, {
          children: ["In ", _jsx(_components.code, {
            children: ".storybook/main.ts"
          }), ", change the ", _jsx(_components.code, {
            children: "stories"
          }), " paths in ", _jsx(_components.code, {
            children: "config"
          }), " to the directories you'd like to capture. For instance, if you'd like to write stories in the UI package:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/storybook/.storybook/main.ts",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "const config = {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  stories: ["
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-   \"../src/**/*.mdx\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-   \"../src/**/*.stories.@(js|jsx|mjs|ts|tsx)\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+   \"../../../packages/ui/src/**/*.stories.@(js|jsx|mjs|ts|tsx)\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "};"
                })
              })]
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "move-story-files-to-the-ui-package",
          children: "Move story files to the UI package"
        }), _jsxs(_components.p, {
          children: ["Following along with ", _jsx(_components.a, {
            href: "/docs/guides/tools/storybook#set-up-a-story-for-your-button-component",
            children: "the guide above"
          }), ", move the ", _jsx(_components.code, {
            children: "./apps/storybook/src/stories/Button.stories.tsx"
          }), " file to ", _jsx(_components.code, {
            children: "./packages/ui/src/Button.stories.tsx"
          }), "."]
        }), _jsx(_components.p, {
          children: "Update components imports so that they reference the now co-located modules. For instance, in the story's imports:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/ui/src/Button.stories.tsx",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "- import { Button } from \"@repo/ui/button\";"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ import { Button } from \"./button\";"
                })
              })]
            })
          })
        }), _jsx(Callout, {
          type: "good-to-know",
          children: _jsxs(_components.p, {
            children: ["You may also need to update ", _jsx(_components.a, {
              href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
              children: "absolute\nimports"
            }), "\naccording to your changes and usage."]
          })
        }), _jsxs(_components.p, {
          children: ["You'll also need to install any Storybook packages required for writing stories. For example, moving the story from above would require that you install ", _jsx(_components.code, {
            children: "@storybook/react"
          }), " into your ", _jsx(_components.code, {
            children: "@repo/ui"
          }), " package."]
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @storybook/react"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=@repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " workspace"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @storybook/react"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @storybook/react"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --workspace=@repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @storybook/react"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=@repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    })]
                  })
                })
              })
            })
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "configure-caching",
          children: "Configure caching"
        }), _jsx(_components.p, {
          children: "Because stories are now in the UI package, changes to those stories can cause cache misses for any builds that depend on your UI package. However, changing a story doesn't mean your production applications should miss cache."
        }), _jsxs(_components.p, {
          children: ["To prevent this, exclude stories from the inputs to your ", _jsx(_components.code, {
            children: "build"
          }), " task in your root ", _jsx(_components.code, {
            children: "turbo.json"
          }), ". You'll also need to create a ", _jsx(_components.code, {
            children: "build:storybook"
          }), " task, which you'll need in a moment:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"!**/*.stories.{tsx,jsx,mdx}\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\".next/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"!.next/cache/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build:storybook\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {} "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["Additionally, create a ", _jsx(_components.a, {
            href: "/docs/reference/package-configurations",
            children: "Package Configuration"
          }), " in the ", _jsx(_components.code, {
            children: "storybook"
          }), " application so stories are ", _jsx(_components.strong, {
            children: "accounted for in building the Storybook application, specifically"
          }), ":"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/storybook/turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"extends\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"//\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build:storybook\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^build:storybook\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"storybook-static/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsx(Callout, {
          type: "good-to-know",
          children: _jsxs(_components.p, {
            children: ["If you are using the ", _jsx(_components.a, {
              href: "/docs/core-concepts/internal-packages#compiled-packages",
              children: "Compiled Package\npattern"
            }), ", you may\nalso need to add ", _jsx(_components.code, {
              children: "^build"
            }), " to your ", _jsx(_components.code, {
              children: "dependsOn"
            }), "."]
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "rename-the-build-script",
          children: "Rename the build script"
        }), _jsx(_components.p, {
          children: "Last, make sure your script to build Storybook uses the configuration we just wrote by renaming it to the name of the task:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "apps/storybook/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"storybook dev -p 6006\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build:storybook\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"storybook build\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["The script that was once ", _jsx(_components.code, {
            children: "\"build\""
          }), " is now ", _jsx(_components.code, {
            children: "\"build:storybook\""
          }), " to ensure the stories are included in hashes for caching."]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "verify-your-configuration",
          children: "Verify your configuration"
        }), _jsx(_components.p, {
          children: "To ensure your setup is correct:"
        }), _jsxs(_components.ol, {
          children: ["\n", _jsxs(_components.li, {
            children: ["Run ", _jsx(_components.code, {
              children: "turbo build:storybook build"
            }), ". You should see cache misses."]
          }), "\n", _jsxs(_components.li, {
            children: ["Run ", _jsx(_components.code, {
              children: "turbo build:storybook build"
            }), " again. You should see all cache hits."]
          }), "\n", _jsxs(_components.li, {
            children: ["Make a code change ", _jsx(_components.strong, {
              children: "to a story"
            }), " in your ", _jsx(_components.code, {
              children: "@repo/ui"
            }), " package."]
          }), "\n", _jsxs(_components.li, {
            children: ["Run ", _jsx(_components.code, {
              children: "turbo build:storybook build"
            }), " again. You should ", _jsx(_components.strong, {
              children: "only"
            }), " see a cache miss for the Storybook application. All others should hit cache."]
          }), "\n"]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "adding-css",
      children: "Adding CSS"
    }), "\n", _jsxs(_components.p, {
      children: ["If your UI package exports its own CSS, you'll need to add it to the renders in the Storybook app, similar to how you would add it to your applications. ", _jsx(_components.a, {
        href: "https://storybook.js.org/docs/configure/styling-and-css#css",
        children: "The Storybook documentation"
      }), " recommends you add it to the ", _jsx(_components.code, {
        children: ".storybook/preview.ts"
      }), " file."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
